import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useIsMounted} from '@chekin/guestapp-ui-kit';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type useMutateDealsProps = {
  onError?: (error: Error) => void;
};
function useMutateDeals({onError}: useMutateDealsProps = {}) {
  const isMounted = useIsMounted();
  const queryClient = useQueryClient();

  const {mutate: deleteDealMutation, mutateAsync: deleteDealAsyncMutation} = useMutation<
    unknown,
    Error,
    string
  >({
    mutationFn: (dealId: string) => API.upselling.deleteDeal(dealId),
    onSuccess: () => {
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.paymentsCart],
      });
    },
    onError: error => {
      if (!isMounted.current) {
        return;
      }
      onError?.(error);
    },
  });

  return {deleteDealMutation, deleteDealAsyncMutation};
}

export {useMutateDeals};
